import { supabase } from "../../config/supabase";

export { supabase };

export const DEFAULT_WEB_SETTINGS = {
	phone: "+91 97461 67477",
	email: "support@funmiyo.com",
	address: "Kerala, India",
	price_per_student: 550,
};

export function phoneDigits(phone) {
	return String(phone || "").replace(/\D/g, "");
}

export function whatsappHref(phone) {
	return `https://wa.me/${phoneDigits(phone)}`;
}

export function telHref(phone) {
	const digits = phoneDigits(phone);
	return digits ? `tel:+${digits}` : "#";
}

export function formatPriceRupee(amount) {
	const n = Number(amount);
	if (!Number.isFinite(n)) return "₹550";
	return `₹${n.toLocaleString("en-IN")}`;
}
